var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDropdown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Dropdown 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCE6-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header/Right-Side",
    transform: "translate(-411.000000, -26.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(121.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(198.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Dropdown",
    transform: "translate(92.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.59743806,3.29841219 L7.44745044,6.49942176 C7.53820664,6.60135516 7.5385127,6.80455108 7.44745044,6.90682824 L4.59743806,10.1078378 C4.39060737,10.340141 4.43815944,10.6751708 4.70364857,10.8561478 C4.9691377,11.0371249 5.35202856,10.9955168 5.55885925,10.7632136 L8.40887163,7.56220399 C8.8434357,7.0741206 8.84231619,6.33087202 8.40887163,5.84404601 L5.55885925,2.64303644 C5.35202856,2.41073323 4.9691377,2.36912514 4.70364857,2.55010216 C4.43815944,2.73107917 4.39060737,3.06610899 4.59743806,3.29841219 Z",
    id: "Arrow---More-Copy",
    transform: "translate(6.601562, 6.703125) scale(-1, 1) rotate(90.000000) translate(-6.601562, -6.703125) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdown);
export default __webpack_public_path__ + "static/media/icon-dropdown.5279f5f8ccfe0f33b1839749b546fe2e.svg";
export { ForwardRef as ReactComponent };